import { useState, useRef, useEffect } from 'react';

/**
 * Hook for tracking which swimlane is currently in view at the sticky header
 */
const useSwimlaneTracking = ({ hasSwimlanes, swimlanes, boardRef }) => {
  const [currentSwimlaneId, setCurrentSwimlaneId] = useState(null);
  const swimlaneRowRefs = useRef({});

  useEffect(() => {
    if (!hasSwimlanes || !boardRef.current) return;

    if (swimlanes.length > 0 && !currentSwimlaneId) {
      setCurrentSwimlaneId(swimlanes[0].id);
    }

    const headerHeight = 38;
    
    const handleScroll = () => {
      if (!boardRef.current) return;
      
      const containerRect = boardRef.current.getBoundingClientRect();
      let foundSwimlane = null;
      
      for (const swimlane of swimlanes) {
        const rowEl = swimlaneRowRefs.current[swimlane.id];
        if (!rowEl) continue;
        
        const rowRect = rowEl.getBoundingClientRect();
        const relativeTop = rowRect.top - containerRect.top;
        
        if (relativeTop <= headerHeight && rowRect.bottom > containerRect.top + headerHeight) {
          foundSwimlane = swimlane.id;
        }
      }
      
      if (foundSwimlane && foundSwimlane !== currentSwimlaneId) {
        setCurrentSwimlaneId(foundSwimlane);
      }
    };

    const container = boardRef.current;
    container.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => container.removeEventListener('scroll', handleScroll);
  }, [hasSwimlanes, swimlanes, currentSwimlaneId, boardRef]);

  return {
    currentSwimlaneId,
    swimlaneRowRefs,
  };
};

export default useSwimlaneTracking;

